module.exports = __webpack_public_path__ + "img/10.262a2aad.png";